import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const PharmaciesTab = ({ buyingGroup }) => {
  return (
    <div style={{ padding: '1vw' }}>
      <table className="highlight">
        <thead>
          <tr>
            <th style={{ padding: '4px' }}>Name</th>
            <th style={{ padding: '4px' }}>Customer Number</th>
          </tr>
        </thead>
        <tbody>
          {buyingGroup?.pharmacies?.map(({ id, name, customerNumber }) => (
            <tr key={id}>
              <td style={{ padding: '4px' }}>
                <Link to={`/pharmacy/${id}`} target="blank">{name}</Link>
              </td>
              <td style={{ padding: '4px' }}>{customerNumber}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PharmaciesTab;
